/**
 * The door to the `program-workstation` chunk: the workstation window (ProgramWorkstationModal), 2026-10-09
 * (docs/PLAN-windows-workstation-20261009.md).
 *
 * The window opens only when someone opens a desktop program's workstation, so it never rides the first download.
 * Its host (ProgramWorkstationModalHost, on the first download) holds the request until it arrives; it is fetched
 * at once when the window is asked for. The window is loaded here and nowhere else (scripts/check-chat-first-paint.mjs, R4).
 */
import { createOnDemandModule } from '../../utils/onDemandModule';
// A TYPE-only import: erased at build, never an edge into the chunk.
import type * as ProgramWorkstationModalNamespace from './ProgramWorkstationModal';

export type ProgramWorkstationModalModule = typeof ProgramWorkstationModalNamespace;

const surface = createOnDemandModule<ProgramWorkstationModalModule>(
  () => import(/* webpackChunkName: "program-workstation" */ './ProgramWorkstationModal'),
);

/** The workstation window once it has arrived, or null; fetched as soon as it is asked for. */
export const useProgramWorkstationModule = (asked: boolean): ProgramWorkstationModalModule | null => surface.useModule(asked, asked);

/** Tests only: forget the download. */
export const resetProgramWorkstationForTests = surface.resetForTests;
